module.exports = __webpack_public_path__ + "img/service-points.61a1c57.png";